import { SubscriptionsState, IUserMailingSetting } from "../type";
import { addUserToSub } from "./addUserToSub";
import { removeUserFromSub } from "./removeUserFromSub";

export function syncUserInSubscriptions(
  state: SubscriptionsState,
  user: IUserMailingSetting,
) {
  user.pledgeBook
    ? addUserToSub(state, "pledgeBook", user)
    : removeUserFromSub(state, "pledgeBook", user.userId);

  user.orderPd
    ? addUserToSub(state, "orderPd", user)
    : removeUserFromSub(state, "orderPd", user.userId);

  const acc = user.accountsReceivable || user.overdAccountsReceivable;
  acc
    ? addUserToSub(state, "accountsReceivable", user)
    : removeUserFromSub(state, "accountsReceivable", user.userId);

  user.salesAndRemainsWeekly
    ? addUserToSub(state, "salesAndRemainsWeekly", user)
    : removeUserFromSub(state, "salesAndRemainsWeekly", user.userId);
  user.salesAndRemainsMonthly
    ? addUserToSub(state, "salesAndRemainsMonthly", user)
    : removeUserFromSub(state, "salesAndRemainsMonthly", user.userId);
}
